export const songTitleWithArtists = (song) => {
  let ret = song.title
  if (song.artists && song.artists.length > 0) {
    ret += ' - ' + song.artists.map((artist) => artist.name).join(', ')
  }

  return ret
}
